import React from 'react';
import { motion } from 'framer-motion';
interface ModuleCardProps {
  title: string;
  subtitle?: string;
  icon: string; // Emoji or image URL
  bgColor: string;
  textColor: string;
  onClick: () => void;
  delay?: number;
}
export function ModuleCard({
  title,
  subtitle,
  icon,
  bgColor,
  textColor,
  onClick,
  delay = 0
}: ModuleCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.5,
    ease: 'easeOut'
  }} whileHover={{
    y: -8
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className="cursor-pointer h-full" data-id="element-20">
      <div className="relative h-full rounded-3xl p-6 flex flex-col items-center text-center transition-shadow duration-300 hover:shadow-xl" style={{
      backgroundColor: bgColor
    }} data-id="element-21">
        {/* Icon Container */}
        <div className="w-24 h-24 flex items-center justify-center mb-4 text-6xl transform transition-transform duration-300 group-hover:scale-110" data-id="element-22">
          {icon}
        </div>

        <h3 className="text-xl font-bold mb-2 font-display" style={{
        color: textColor
      }} data-id="element-23">
          {title}
        </h3>

        {subtitle && <p className="text-slate-600 text-sm font-medium leading-relaxed opacity-80" data-id="element-24">
            {subtitle}
          </p>}
      </div>
    </motion.div>;
}